import React, { Component } from 'react';
import { Grid, Row, Col, Icon } from 'rsuite';

class Deadlines extends Component {

    componentDidMount = () => {
        // console.log(this.props)
    }


  render() {
    return (
      <div className="r_container">
        <div className="home">

          <div className="new_banner">
            <div className="banner_content">
              <h1>LLM 2025</h1>
              
              <h6>The 2025 International Conference on Large Language Models (LLM)</h6>
              <h6>December 3-5, 2025, Las Vegas, USA</h6>
            </div>

            <div className="new_banner_overlay"></div>
          </div>
          

          <div className="page_content">
          <h5 className="par_header">DEADLINES (Late Breaking Papers)</h5>
          <h6 className="par_header">FOR PROSPECTIVE AUTHORS:</h6>
            <div className="par">
            Since the books/proceedings will be published after the conference, we have some flexibility with the submission deadlines. Due to numerous requests, the paper submission deadline has been extended as outlined below. Authors who have already submitted their papers in response to the earlier announcement will receive the decision/status report shortly, if they have not yet done so.
            <br /> <br />
          <b>DEADLINES (Late Breaking Papers)</b> <br />
          <br /> 
            - SUBMISSION OF PAPERS (for peer-review evaluation):<br />
            &emsp;<b>October 26, 2025</b> <br /> 
            &emsp;<a target="_blank" href="https://american-cse.org/drafts/">https://american-cse.org/drafts/</a> 
            <br/>            
            <br />

            - NOTIFICATION OF ACCEPTANCE/REJECTION:<br />
            &emsp;<b>REVOLVING DATE</b> <br />
            &emsp;Will be sent about 10 days AFTER the date of submission.

            <br /><br />

            - REGISTRATIONS:<br />
            &emsp;<b>REVOLVING DATE</b> <br />
            &emsp;<a href="https://american-cse.org/LLM2025/registration" target="_blank" rel="noopener noreferrer">https://american-cse.org/LLM2025/registration</a>
            <br /> &emsp; Authors of accepted papers will find the registration deadline in their notification of acceptance.

            <br /><br />
            - LOCATION AND ROOM RESERVATION: <br />
            &emsp;<b>November 7, 2025</b> <br />
            &emsp;Luxor - an MGM property, Las Vegas, USA <br />
            &emsp;<a href="https://www.american-cse.org/LLM2025/venue" target="_blank" rel="noopener noreferrer">https://www.american-cse.org/LLM2025/venue</a>

            
            <br /><br />
            <b>- The 2025 International Conference on Large Language Models (LLM'25):</b> <br />
            &emsp;<b>December 3-5, 2025</b> <br />
            &emsp;<a href="https://www.american-cse.org/LLM2025/" target="_blank" rel="noopener noreferrer">https://www.american-cse.org/LLM2025/</a> <br />
            {/* &emsp; + all affiliated Research Tracks: <br />
            &emsp; <a href="https://www.american-cse.org/LLM2025/topics" target="_blank" rel="noopener noreferrer">https://www.american-cse.org/LLM2025/topics</a> <br /> */}
            
            <br />
            - FINAL PAPERS:<br />
            &emsp; UPLOADING THE FINAL MANUSCRIPTS OF ACCEPTED PAPERS TO SPRINGER PUBLICATION PORTAL/LINK: As in previous years, the conference proceedings will be published after the event. Authors of accepted papers can expect to receive an email with a unique publication link by approximately December 31, 2025. This personalized link - issued by the publisher (Springer Nature) - is associated with each accepted paper and is used for indexing by all relevant indexing organizations.  The conference will also send reminders to ensure that all authors receive their publication details in a timely manner.
            
{/* <br /><br /><br /> */}
            {/* <i>(Note: We will probably extend the deadlines as needed – however, the sooner a paper is submitted, the sooner notification can be sent.)</i> */}
            <br /><br />
            </div>

            <h6 className="par_header">FOR NON-AUTHORS & NON-SPEAKER ATTENDEES:</h6>
            <div className="par">
            
            - REGISTRATIONS:<br />
            &emsp;<b>December 1, 2025</b> <br />
            &emsp;<a href="https://american-cse.org/LLM2025/registration" target="_blank" rel="noopener noreferrer">https://american-cse.org/LLM2025/registration</a>

            <br /><br />
            - LOCATION AND ROOM RESERVATION: <br />
            &emsp;<b>November 7, 2025</b> <br />
            &emsp;Luxor - an MGM property, Las Vegas, USA <br />
            &emsp;<a href="https://www.american-cse.org/LLM2025/venue" target="_blank" rel="noopener noreferrer">https://www.american-cse.org/LLM2025/venue</a>

            
            <br /><br />
            <b>- The 2025 International Conference on Large Language Models (LLM'25):</b> <br />
            &emsp;<b>December 3-5, 2025</b> <br />
            &emsp;<a href="https://www.american-cse.org/LLM2025/" target="_blank" rel="noopener noreferrer">https://www.american-cse.org/LLM2025/</a> <br />
            {/* &emsp; + all affiliated Research Tracks: <br />
            &emsp; <a href="https://www.american-cse.org/LLM2025/topics" target="_blank" rel="noopener noreferrer">https://www.american-cse.org/LLM2025/topics</a> <br /> */}
            

            </div>

          
          </div>
          

        </div>
      </div>
    );
  }
}

export default Deadlines;